export namespace StoreState {
  export interface IStoreState {
    showAboveFooter: boolean;
  }

  export const initialState: IStoreState = {
    showAboveFooter: false,
  };
}
